/**
 * Key of the Relations conversation an email belongs to — the `:threadKey`
 * segment of `/admin/relations/:threadKey`. Mirrors the SQL definition used by
 * every relations RPC: `coalesce(gmail_thread_id, id::text)`.
 */
export function emailThreadKey(email: { id: string; gmail_thread_id: string | null }): string {
  return email.gmail_thread_id ?? email.id;
}

export function relationsThreadPath(threadKey: string): string {
  return `/admin/relations/${encodeURIComponent(threadKey)}`;
}
